"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-use-before-define
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const apollo_boost_1 = require("apollo-boost");
const react_hooks_1 = require("@apollo/react-hooks");
const core_1 = require("@material-ui/core");
const ActionButtons_1 = __importDefault(require("coact/pages/modules/pageAction/ActionButtons"));
const DataTableView_1 = __importDefault(require("../ui/DataTableView"));
const AssertionInfoStatus_1 = require("./AssertionInfoStatus");
const DataTableField_1 = require("../stockRecordWorkflow/ui/DataTableField");
const AssertInfosDownloaderView_1 = __importDefault(require("../stockManagement/ui/Downloader/AssertInfosDownloaderView"));
exports.AssertInfoStatusDesc = {
    [AssertionInfoStatus_1.AssertionInfoStatus.Unknown]: '不明',
    [AssertionInfoStatus_1.AssertionInfoStatus.Created]: '新建立',
    [AssertionInfoStatus_1.AssertionInfoStatus.Asserting]: '盤點中',
    [AssertionInfoStatus_1.AssertionInfoStatus.Submitted]: '已送出',
    [AssertionInfoStatus_1.AssertionInfoStatus.Finished]: '已認列',
    [AssertionInfoStatus_1.AssertionInfoStatus.Cancelled]: '已取消',
    [AssertionInfoStatus_1.AssertionInfoStatus.Deleted]: '已刪除',
};
const CREATE_ASSERT_INFO = apollo_boost_1.gql `
  mutation ($warehouseId: String!) {
    createAssertionInfo(warehouseId: $warehouseId)
  }
`;
const GET_ASSERT_INFOS = apollo_boost_1.gql `
  query {
    getStoreWarehouses{
      id
      name
    }
    getAssertionInfos {
      id
      sn
      status
      warehouse {
        name
      }
      startDate
      submitDate
    }
  }
`;
function AssertionInfosView(props) {
    const [selectedWarehouse, setSelectedWarehouse] = react_1.useState('');
    const { data, loading, refetch } = react_hooks_1.useQuery(GET_ASSERT_INFOS);
    const [createAssertInfo] = react_hooks_1.useMutation(CREATE_ASSERT_INFO);
    react_1.useEffect(() => {
        if (data === undefined) {
            return;
        }
        setSelectedWarehouse(data.getStoreWarehouses[0].id);
    }, [data]);
    if (loading)
        return react_1.default.createElement(react_1.default.Fragment, null);
    const actions = [
        {
            text: '創建',
            props: {},
            onClick: () => __awaiter(this, void 0, void 0, function* () {
                yield createAssertInfo({
                    variables: {
                        warehouseId: selectedWarehouse,
                    },
                }).then(() => {
                    refetch();
                });
            }),
        },
    ];
    const header = {
        getUniqueId(info) {
            if (info.id) {
                return info.id;
            }
            console.error('Id not found.');
            return '(N/A)';
        },
    };
    const fields = [
        {
            label: '盤點單號',
            textAlign: DataTableField_1.TextAlignment.Left,
            width: 300,
            toFormat(info) {
                if (info.sn)
                    return info.sn;
                console.error('sn not found');
                return '(N/A)';
            },
        },
        {
            label: '狀態',
            textAlign: DataTableField_1.TextAlignment.Left,
            width: 100,
            toFormat(info) {
                return exports.AssertInfoStatusDesc[info.status];
            },
        },
        {
            label: '開始時間',
            textAlign: DataTableField_1.TextAlignment.Left,
            width: 100,
            toFormat(info) {
                if (info.startDate == null)
                    return '';
                return moment_1.default(info.startDate).format('YYYY/MM/DD');
            },
        },
        {
            label: '送出時間',
            textAlign: DataTableField_1.TextAlignment.Left,
            width: 100,
            toFormat(info) {
                if (info.submitDate == null)
                    return '';
                return moment_1.default(info.submitDate).format('YYYY/MM/DD');
            },
        },
        {
            label: '盤點單位',
            textAlign: DataTableField_1.TextAlignment.Left,
            width: 200,
            toFormat(info) {
                if (info.warehouse) {
                    return info.warehouse.name;
                }
                console.error('warehouse not found.');
                return '(N/A)';
            },
        },
    ];
    const onMouseUp = (index) => {
        props.history.push(`${props.rootPath}/${data.getAssertionInfos[index].id}`);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ActionButtons_1.default, { actions: actions, classes: null }),
            react_1.default.createElement(core_1.Select, { value: selectedWarehouse, onChange: (e) => setSelectedWarehouse(e.target.value) }, data
                .getStoreWarehouses
                .map((e) => react_1.default.createElement(core_1.MenuItem, { key: e.id, value: e.id }, e.name))),
            react_1.default.createElement(AssertInfosDownloaderView_1.default, { canDisplayCost: props.canDisplayCost })),
        react_1.default.createElement(DataTableView_1.default, { header: header, fields: fields, data: data.getAssertionInfos, createMouseUpHandler: () => onMouseUp })));
}
exports.default = AssertionInfosView;
